<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="720" scrollable persistent no-click-animation>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar facturas</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="close" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0 background-card">
        <v-row class="mx-0 py-4">
          <v-col cols="12" class="py-0">
            <v-text-field v-model="query" background-color="white" outlined single-line dense hide-details clearable placeholder="Buscar por cliente o número de documento">
              <template v-slot:prepend-inner>
                <v-icon class="mt-1" color="secondary" small>mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider />
        <v-skeleton-loader v-if="loading" class="pa-4" transition="fade-transition" type="table-tbody" />
        <v-row v-else-if="!results.length" class="mx-0 py-8" justify="center">
          <v-col class="text-center py-2" cols="8">
            <v-icon class="my-1 d-block" color="secondary" size="40">mdi-file-search-outline</v-icon>
            <span class="my-1 d-block body-2">No encontramos facturas por cobrar con ese criterio.</span>
          </v-col>
        </v-row>
        <v-simple-table v-else>
          <template v-slot:default>
            <tbody>
              <tr v-for="i in results" :key="i.id" @click="toggle(i)" :style="{ cursor: isSelected(i) ? 'default' : 'pointer' }">
                <td style="width:48px;">
                  <v-simple-checkbox :value="isPicked(i) || isSelected(i)" :disabled="isSelected(i)" @input="toggle(i)" :ripple="false" />
                </td>
                <td>
                  <span class="d-block">{{i.document.name}}</span>
                  <span class="d-block body-2 text--secondary font-weight-medium">Nº {{i.number}}</span>
                </td>
                <td>{{i.customer.name}}</td>
                <td class="text-right">
                  <span class="d-block body-2">Vence</span>
                  <span class="d-block" v-if="i.due_date">{{i.due_date | date}}</span>
                  <span class="d-block" v-else>---</span>
                </td>
                <td class="text-right">
                  <span class="body-2 text--secondary font-weight-medium">{{i.total | currency(i.currency)}}</span>
                  <span class="ml-1">{{i.currency}}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <span class="body-2 text--secondary" v-if="picked.length">{{picked.length}} seleccionada(s)</span>
        <v-spacer />
        <v-btn @click="close" outlined>Cancelar</v-btn>
        <v-btn @click="confirm" :disabled="!picked.length" color="primary">Agregar<template v-if="picked.length"> ({{picked.length}})</template></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => ([])
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    loading: false,
    picked: [],
    query: '',
    results: []
  }),
  watch: {
    query () {
      this.debounceMethod(this.getList)
    },
    value (open) {
      if (open) {
        this.query = ''
        this.picked = []
        this.getList()
      }
    }
  },
  methods: {
    getList () {
      if ([1, 2].includes((this.query || '').length)) {
        return false
      }

      const query = { page_size: 10, status: 'finalized' }
      const term = (this.query || '').trim()

      if (term.length >= 3) {
        if (/^\d+$/.test(term)) {
          query.number = term
        } else {
          query.customer__name__icontains = term.toLowerCase()
        }
      }

      this.loading = true

      // setState y loader en false: de lo contrario el picker pisa el listado
      // de Facturas en el store y enciende el skeleton de esa página
      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query: query,
        setState: false,
        loader: false
      })
      .then((response) => {
        this.results = response.data.results
      })
      .catch(() => {
        this.results = []
      })
      .finally(() => {
        this.loading = false
      })
    },
    isPicked (invoice) {
      return this.picked.some(i => i.id === invoice.id)
    },
    isSelected (invoice) {
      return this.selected.some(i => i.id === invoice.id)
    },
    toggle (invoice) {
      if (this.isSelected(invoice)) {
        return false
      }

      this.picked = this.isPicked(invoice)
        ? this.picked.filter(i => i.id !== invoice.id)
        : this.picked.concat([invoice])
    },
    confirm () {
      this.$emit('select', this.picked)
      this.close()
    },
    close () {
      this.$emit('input', false)
    }
  }
}
</script>
